import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal from "./Reveal";

export default function Faq({ t }) {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 md:py-32 border-t border-[var(--border)]">
      <div className="container-x grid grid-cols-12 gap-6 md:gap-12">
        <div className="col-span-12 md:col-span-4">
          <Reveal>
            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display">
              <span className="w-6 h-[1px] bg-[var(--accent)]" />
              {t.faq.overline}
            </div>
          </Reveal>
          <Reveal delay={0.05} y={30}>
            <h3 className="mt-5 font-display font-black uppercase leading-[0.95] tracking-tighter text-5xl md:text-7xl text-[var(--text)]">
              {t.faq.title}
            </h3>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-8">
          <div className="border-t border-[var(--border)]">
            {t.faq.items.map((it, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={i} delay={i * 0.04}>
                  <div className="border-b border-[var(--border)]" data-testid={`faq-item-${i}`}>
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
                      data-testid={`faq-trigger-${i}`}
                      aria-expanded={isOpen}
                      data-state={isOpen ? "open" : "closed"}
                    >
                      <span className="font-display uppercase tracking-tight text-lg md:text-2xl text-[var(--text)] group-hover:text-[var(--accent)] transition-colors">
                        {it.q}
                      </span>
                      <span
                        className={`shrink-0 w-9 h-9 rounded-full border border-[var(--border)] flex items-center justify-center text-[var(--text)] transition-all duration-500 ${
                          isOpen ? "rotate-45 bg-[var(--accent)] text-[var(--bg)] border-[var(--accent)]" : ""
                        }`}
                        aria-hidden
                      >
                        +
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                          className="overflow-hidden"
                        >
                          <p className="pb-6 md:pb-8 pr-12 text-[var(--text-muted)] leading-relaxed text-base md:text-lg max-w-2xl">
                            {it.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
